export default {
  /**
   *
   * @param state
   * @param items
   */
  setEmployeeDailyAttendance(state, items) {
    console.log("Items", items);
    state.items = items;
  },

  /**
   *
   * @param state
   * @param pagination
   */
  setEmployeeDailyAttendancePagination(state, pagination) {
    console.log("Pagination", pagination);
    state.pagination = pagination;
  },

  /**
   *
   * @param state
   * @param currentPage
   */
  setEmployeeDailyAttendancePage(state, currentPage) {
    console.log("Current Page", currentPage);
    state.pagination.current_page = currentPage;
  },

  /**
   * Set filters.
   *
   * @param state
   * @param filters
   */
  setEmployeeDailyAttendanceFilters(state, filters) {
    state.filters = filters;
  },

  /**
   * Set is busy
   *
   * @param state
   * @param isBusy
   */
  setEmployeeDailyAttendanceBusy(state, isBusy) {
    state.isBusy = isBusy;
  },
};
